import { render, staticRenderFns } from "./Base-Input-String.vue?vue&type=template&id=0c06d69a&scoped=true&"
import script from "./Base-Input-String.vue?vue&type=script&lang=js&"
export * from "./Base-Input-String.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06d69a",
  null
  
)

export default component.exports